// extracted by mini-css-extract-plugin
module.exports = {"page":"_3574","image":"_18148"};